module.exports = __webpack_public_path__ + "img/DSC_0180 teatro 3.bacd09f8.jpg";